import { createContext, } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// local
import { Theme } from "./theme";
import GlobalCss from "./styles/jss/GlobalCss";

// components
import { PopupContextProvider } from "./hooks/PopupContext";
import { MainLayout } from "./layout/MainLayout";
import ConfirmDialog from "./components/molecular/ConfirmDialog";
import InfoDialog from "./components/molecular/InfoDialog";

// pages
import Error from "./pages/error/Error";
import HomePage from "./pages/home/HomePage";
import CompanyPage from "./pages/company/CompanyPage";
import ContactUsPage from "./pages/contact/ContactUsPage";
import WorkDataHubXPage from "./pages/works/Work_DataHubX";
import WorkStrgyMasterProPage from "./pages/works/Work_StrgyMasterPro";
import WorkGridSyncPage from "./pages/works/Work_GridSync";
import WorkFlexFlowPage from "./pages/works/Work_FlexFlow";
import WorkFlexTrading2Page from "./pages/works/Work_FlexTrading2";
import SvcDataHubPage from "./pages/services/Service_DataHub";
import SvcStrgyDevPage from "./pages/services/Service_StrgyDev";
import SvcMaintSupportPage from "./pages/services/Service_SystemDev";
import SvcAlgorithmPage from "./pages/services/Service_Algorithm";

export const NesContext = createContext();

export default function App() {
  const MainRouter = () => {
    return (
      <Routes>
        <Route element={<MainLayout />} >
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="home" element={<HomePage />} />
          <Route path="company" element={<CompanyPage />} />
          <Route path="contact" element={<ContactUsPage />} />
          <Route path="prod_data_hub_x" element={<WorkDataHubXPage />} />
          <Route path="prod_strgy_master_pro" element={<WorkStrgyMasterProPage />} />
          <Route path="prod_grid_sync" element={<WorkGridSyncPage />} />
          <Route path="prod_flex_flow" element={<WorkFlexFlowPage />} />
          <Route path="prod_flex_trading2" element={<WorkFlexTrading2Page />} />
          <Route path="svc_data_hub" element={<SvcDataHubPage />} />
          <Route path="svc_algorithm" element={<SvcAlgorithmPage />} />
          <Route path="svc_maint_support" element={<SvcMaintSupportPage />} />
          <Route path="svc_strgy_dev" element={<SvcStrgyDevPage />} />
          <Route path="*" element={<Error />} />
        </Route>
      </Routes>);
  };

  return (
    <PopupContextProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ja'}>
        <ThemeProvider theme={Theme}>
          <GlobalCss>
            <PerfectScrollbar
              id="main-content"
              className="h-full-screen scrollable-content"
              options={{ suppressScrollX: true }}
            >
              <SnackbarProvider maxSnack={3}>
                <BrowserRouter>
                  <MainRouter />
                </BrowserRouter>
              </SnackbarProvider>
            </PerfectScrollbar>
          </GlobalCss>
        </ThemeProvider>
      </LocalizationProvider >
      <ConfirmDialog />
      <InfoDialog />
    </PopupContextProvider>
  );

}
